import styled from 'styled-components';

import { ReactComponent as TrashIconBase } from 'assets/icons/primary-trash.svg';
import { ReactComponent as PenIconBase } from 'assets/icons/primary-pen.svg';
import { ReactComponent as ClosedEyeIconBase } from 'assets/icons/closed-eye.svg';

export const TrashIcon = styled(TrashIconBase)`
  cursor: pointer;
`;

export const PenIcon = styled(PenIconBase)`
  cursor: pointer;
`;

export const ClosedEyeIcon = styled(ClosedEyeIconBase)`
  cursor: pointer;
  grid-column: 5;
`;
